export default __webpack_public_path__ + "static/media/exit-icon.1702d564.svg";